import {
  jsonApiRequestStreaming,
  jsonGet,
  jsonDelete,
  jsonPost,
} from "../../../Boilerplate/api";

export async function sendAssistantMessage(message, conversationId, pageContext, onChunk) {
  return jsonApiRequestStreaming("POST", "assistant/chat", {
    message,
    conversationId,
    pageContext,
  }, onChunk);
}

export async function listConversations() {
  return jsonGet("assistant/conversations");
}

export async function getConversation(conversationId) {
  return jsonGet(`assistant/conversations/${conversationId}`);
}

export async function deleteConversation(conversationId) {
  return jsonDelete(`assistant/conversations/${conversationId}`);
}

export async function flagConversation(conversationId, reason) {
  return jsonPost(`assistant/conversations/${conversationId}/flag`, { reason });
}
